import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccessControlService } from './access-control.service';

@Injectable({ providedIn: 'root' })
export class PrivilegesGuard {
  constructor(private accessControlService: AccessControlService) {}

  public canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.accessControlService.getPrivileges().pipe(map(() => true));
  }
}
